import { FormLabel, Grid } from '@mui/material';
import clsx from 'clsx';
import React from 'react';

const GridFormLabel = ({ children, required, error }) => {
  return (
    <Grid item xs={12} sm={12} md={2} style={{ position: 'relative' }}>
      <FormLabel component="div" className={clsx(error && 'text-red-500')}>
        {children}
        {required && <span className="text-error"> *</span>}
      </FormLabel>
    </Grid>
  );
};

export default GridFormLabel;
